<template>
  <div
    class="flex flex-col w-full cursor-pointer"
    :class="{ 'bg-white border rounded border-brand-gray-300': multiList }"
  >
    <div
      v-if="icons"
      class="flex items-center justify-between px-4 py-2 bg-white"
      @click="showlistMenu"
    >
      <span class="text-gray-600 font-normal text-lg">
        {{ $t('CreateSponsorFile') }}
      </span>
      <div class="bg-primary h-5 w-5 rounded-full flex items-center justify-center text-white">
        <i :class="[isOpen ? 'fa-minus' : 'fa-plus']" class="fa"></i>
      </div>
    </div>

    <div
      class="w-full h-48 overflow-scroll dropdown bg-white"
      v-if="isOpen"
      :class="[isOpen ? 'p-2' : '']"
    >
      <slot name="input" />
      <ul
        class="px-3 py-2"
        :class="[
          multiList
            ? 'border-b border-brand-gray-300 hover:text-primary'
            : 'border-t border-brand-gray-300'
        ]"
        v-for="(item, index) in listItems"
        :key="index"
      >
        <li
          class="flex items-center gap-3 list-none cursor-pointer"
          @click.prevent="selected(item)"
          :key="item.id"
        >
          <faChevronRight class="w-3 h-3 fill-primary" v-if="icons" />
          <slot name="list" :item="item">
            <span v-if="item.label">
              {{ item.label }}
            </span>
          </slot>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'

const emits = defineEmits(['selected'])

const props = defineProps({
  listItems: {
    type: Array,
    default: () => []
  },
  icons: {
    type: Boolean,
    default: false
  },
  multiList: {
    type: Boolean,
    default: false
  },
  open: {
    type: Boolean,
    default: false
  }
})

const isOpen = ref(props.open)

const showlistMenu = () => {
  isOpen.value = !isOpen.value
}

const selected = (item) => {
  emits('selected', item)
}
</script>

<style>
.dropdown::-webkit-scrollbar {
  display: none;
}
</style>
